/**
 * Dynamic Content
 */


document.addEventListener('DOMContentLoaded', function () {

	const selectedGoal = document.getElementById('selected-goal')
	const selectedGoalText = document.getElementById('selected-goal-text')

	const updateContent = (goal) => {
		const target = goal.target.value
		const formats = document.getElementsByClassName('format');

		selectedGoal.style.display = 'flex'
		selectedGoalText.innerHTML = `Your goal: <strong>${goal.target.labels[0].textContent}</strong>`

		for (const format of formats) {
			if ( target === format.getAttribute('ID') ) {
				format.classList.add('selected')
			} else if ( format.classList.contains('selected') ) {
				format.classList.remove('selected')
			}
		}

	}

	const goals = document.getElementsByName('goal');

	for (const goal of goals) {
		goal.addEventListener('change', updateContent)
	}

}, false);